import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass';
import styled from 'styled-components';
import { display } from 'styled-system';
import { Form, Dropdown } from 'formsy-semantic-ui-react';
import _throttle from 'lodash/throttle';

import { SPACE } from '../../../Components/Theme';
import { Button } from '../../../Components/Base';

const FormContainer = styled(Flex)`
  ${display};
`;

class LinkMockExamPanel extends Component {
  static propTypes = {
    dropdownOptions: PropTypes.array,
  };

  handleSubmit = _throttle(formData => {
    const { round } = formData;
    if (round && this.props.onSubmit) {
      this.props.onSubmit(round);
    }
  });

  render() {
    const { dropdownOptions } = this.props;
    return (
      <Form onValidSubmit={this.handleSubmit} width={'100%'}>
        <FormContainer display={['block', 'flex']}>
          <Box
            mr={[SPACE.none, SPACE.small]}
            mb={[SPACE.xsmall, SPACE.none]}
            style={{ flexGrow: 1 }}
          >
            <Dropdown
              placeholder={'เลือกรอบการสอบ Mock Exam'}
              name={'round'}
              fluid
              style={{ minWidth: '200px' }}
              selection
              options={dropdownOptions}
            />
          </Box>
          <Button type={'submit'} color="red" basic>
            ใส่คะแนนอัตโนมัติ
          </Button>
        </FormContainer>
      </Form>
    );
  }
}

export default LinkMockExamPanel;
